/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { StackedBar } from '../../../CommonComponents/OPL/charts/StackedBar/StackedBar';
import { formatPercentage } from '../../../CommonUtils/formatNumber';
import { PieChart } from '../../../CommonComponents/OPL/charts/PieChart/PieChart';
import { useTheme } from '../../../theme/theme';
import { ChartType } from '../../../CommonSelectors/CommonArea.types';

interface Props {
  chartType?: ChartType;
  size?: number;
  data: {
    label: string;
    value: number;
    color: string;
  }[];
}

export const PercentageChart = ({ chartType = ChartType.Bar, size = 196, data }: Props) => {
  const theme = useTheme();

  if (data.length === 0) {
    return <Box width="100%" height={32} borderRadius="medium" bg="neutral.200" />;
  }

  return (
    <>
      {chartType === ChartType.Bar ? (
        <StackedBar data={data} formatter={value => formatPercentage(value, { mantissa: 2 })} />
      ) : (
        <Box width={size} height={size} mx="auto">
          <PieChart
            series={[
              {
                data: data.map(point => ({
                  color: point.color,
                  name: point.label,
                  y: point.value,
                })),
              },
            ]}
            customSettings={{
              chart: {
                margin: undefined,
                spacingTop: undefined,
                spacingBottom: undefined,
                spacingLeft: undefined,
                spacingRight: undefined,
              },
              plotOptions: {
                pie: {
                  innerSize: chartType === ChartType.Donut ? '70%' : '0%',
                  enableMouseTracking: true,

                  states: {
                    hover: {
                      enabled: true,
                    },
                  },
                },

                series: {
                  animation: false,
                },
              },

              tooltip: {
                enabled: true,
                outside: true,
                formatter() {
                  const { name, y, color } = this.point;

                  return `
                    <div style='display: flex; align-items: flex-start; font-size: 12px; color: ${
                      theme.colors.neutral['100']
                    };'>
                      <div style='width: 8px; height: 8px; border-radius: 4px; margin-top: 5px; margin-right: 4px; background: ${color}; flex-shrink: 0'></div>
                      
                      <div style='margin: 0 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'>
                        ${name}
                      </div>
                      <div style="font-weight: 600">
                        ${formatPercentage(y, { mantissa: 2 })}
                      </div>
                    </div>
                  `;
                },
              },
            }}
          />
        </Box>
      )}
    </>
  );
};
